// Dashboard landing. Real KPI tiles + activity feed land with C4.1. PLAN-C4.0 task-2.
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { useSession } from "../lib/session";
import { getEffectivePermissions } from "@sympllex/auth";
import { PageHeader } from "@/components/page-header";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function DashboardRoute() {
  const session = useSession();
  const permCount = getEffectivePermissions(session).size;
  return (
    <section>
      <PageHeader
        title="Welcome back"
        description={`Signed in as ${session.user.email} · roles: ${session.roleCodes.join(", ") || "none"} · ${permCount} effective permissions`}
      />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Link to="/canonical-libraries" className="group/link block">
          <Card size="sm" className="transition-shadow group-hover/link:shadow-md">
            <CardHeader>
              <CardTitle className="flex items-center justify-between">
                Canonical libraries
                <ArrowRight className="size-4 text-muted-foreground transition-transform group-hover/link:translate-x-0.5" />
              </CardTitle>
              <CardDescription>Manage the platform&apos;s shared reference data.</CardDescription>
            </CardHeader>
            <CardContent />
          </Card>
        </Link>
      </div>
    </section>
  );
}
